import React, { useState, useEffect } from 'react'
import './EditUnitMixDetails.scss'
import {
  unitmixSummaryRentT1,
  unitmixSummaryRentSH1,
  unitmixSummaryRent
} from '@engine/dependencies/constants'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  Dialog,
  IconButton,
  DialogTitle,
  Paper,
  Tabs,
  Tab,
  Box,
  Button
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { EditColumns } from '@components/custom'
import DataTable from '@components/common/DataTable/DataTable'
import { move } from 'ramda'
import { normalize } from '@engine/dependencies'
import EditDisclaimeText from '../../common/EditDisclaimeText/EditDisclaimeText'

const useStyles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  dialogPaper: {
    minHeight: '700px',
    maxHeight: '740px',
    maxWidth: '1350px',
    width: '1350px'
  },
  closeButton: {
    position: 'absolute',
    right: '20px',
    top: '20px',
    color: theme.palette.grey[500]
  },
  tabs: {
    margin: '0 16px',
    borderBottom: '1px solid #DCE1E5'
  },
  tab: {
    '&.MuiTab-textColorPrimary.Mui-selected': {
      borderBottom: '3px solid #02628E',
      zIndex: 1
    },
    '& .MuiTab-wrapper': {
      // fontFamily: '\'Roboto\', sans-serif'
      fontFamily: '\'DIN Pro Light\''
    }
  },
  tabPanelBoxRoot: {
    paddingTop: 0
  }
})

function TabPanel(props) {
  const { children, value, index, classes } = props

  return (
    <div>
      {value === index && (
        <Box p={3} className={classes.tabPanelBoxRoot}>
          {children}
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
  classes: PropTypes.object
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
    'data-testid': `simple-tab-${index}`
  }
}

const EditUnitMixDetails = props => {
  const [tableData, setTableData] = useState({
    localComparableData: props.comparableData,
    checked: false,
    dragIndex: -1,
    reset: false,
    selectedRows: [],
    isLastRec: props.comparableData?.length === 2,
    dialogPropertyFields: {
      reset: false,
      propertyFields: [],
      mandatoryFields: [],
      allFields: [],
      dragIndex: -1
    }
  })
  const [rowInEditFlag, setRowInEditFlag] = useState(false)
  const [editRowIndex, setEditRowIndex] = useState(-1)
  const [isHideTotal, setIsHideTotal] = useState(Boolean(props.hideUnitMixTotal))
  const [unitMixDisclaimerData, setunitMixDisclaimerData] = useState({
    disclaimerText: props.unitMixDisclaimerData?.disclaimerText || '',
    showDisclaimerForm: props.unitMixDisclaimerData?.showDisclaimerForm || false,
    showDisclaimer: props.unitMixDisclaimerData?.showDisclaimer || true
  })

  const {
    classes,
    isDialogOpen,
    unitMixTableColumns,
    templateType,
    rowsCount,
    propertyType,
    closeEditPopup,
    editUnitMixData,
    doneColumnsDialog,
    hideUnitMixTotal,
    togglePropertyWeightedAvg
  } = props
  const dialogProperties =
    templateType === 'T1' ? unitmixSummaryRentT1 : templateType === 'SH1' ? unitmixSummaryRentSH1 : unitmixSummaryRent
  dialogProperties.propertyFields = unitMixTableColumns
  useEffect(() => {
    setTableData({
      ...tableData,
      dialogPropertyFields: {
        ...tableData.dialogPropertyFields,
        ...dialogProperties
      }
    })
  }, [])

  useEffect(() => {
    setIsHideTotal(hideUnitMixTotal)
  }, [hideUnitMixTotal])

  const dialogTitle = 'Unit Mix'
  const DEFAULT_DISCLAIMER_TEXT = '*Subject Property - Is a Market/Affordable property.'
  const [value, setValue] = React.useState(0)

  const handleTabChange = (event, newValue) => {
    setValue(newValue)
  }

  const onDragOver = () => e => {
    e.preventDefault()
  }

  const onDragStart = originalIndex => () => {
    setTableData({
      ...tableData,
      dragIndex: originalIndex
    })
  }

  const onDrop = orderIndex => e => {
    e.preventDefault()
    if (orderIndex === tableData.dragIndex) {
      return
    }
    const rearrangedCData = move(
      tableData.dragIndex,
      orderIndex,
      tableData.localComparableData
    )
    setTableData({
      ...tableData,
      reset: true,
      localComparableData: [...normalize.calculateWtdAvgRowForUnitMix(rearrangedCData, rowsCount)]
    })
  }

  const handleChange = event => {
    let selectAllRows = []
    if (event.target.checked) {
      selectAllRows = Array.from(
        Array(tableData.localComparableData.length - 1).keys()
      )
    } else {
      selectAllRows = []
    }
    setTableData({
      ...tableData,
      checked: event.target.checked,
      selectedRows: selectAllRows,
      reset: true
    })
  }

  const onSelect = selectedRowIndex => {
    let selected = [...tableData.selectedRows]
    if (selected.includes(Number(selectedRowIndex))) {
      selected = selected.filter(row => row !== Number(selectedRowIndex))
    } else {
      selected.push(Number(selectedRowIndex))
    }
    const allSelection =
      tableData.localComparableData.length - 1 === selected.length
    setTableData({
      ...tableData,
      selectedRows: [...selected],
      reset: true,
      checked: allSelection
    })
  }

  const handleReset = () => {
    const cdata = props.comparableData
    setTableData({
      ...tableData,
      reset: false,
      localComparableData: [...cdata],
      selectedRows: [],
      checked: false,
      isLastRec: cdata.length === 2
    })
  }

  const setConditionalDelete = rowNum => {
    const cdata = JSON.parse(JSON.stringify(tableData.localComparableData))
    let tmpData = null
    if (rowNum >= 0) {
      if (cdata[rowNum].omniViewPropertyRentId) {
        tmpData = JSON.parse(JSON.stringify(tableData.localComparableData))
        tmpData[rowNum].isRemoved = true
      } else {
        tmpData = JSON.parse(JSON.stringify(cdata.filter((data, index) => index !== rowNum)))
      }
    } else {
      tmpData = JSON.parse(JSON.stringify(tableData.localComparableData))
      tableData.selectedRows.forEach(rowIndex => {
        if (cdata[rowIndex].omniViewPropertyRentId) {
          tmpData[rowIndex].isRemoved = true
        } else {
          tmpData[rowIndex].canRemovePermanently = true
        }
      })
      tmpData = JSON.parse(JSON.stringify(tmpData.filter(data => !data.canRemovePermanently)))
    }

    return tmpData
  }

  const handleDeleteSelected = () => {
    // const cdata = tableData.localComparableData

    // tableData.selectedRows.forEach(rowIndex => {
    //   // cdata[rowIndex] = { ...cdata[rowIndex], isRemoved: true }
    //   handleDeleteRow(rowIndex)
    // })
    if (tableData.localComparableData.length <= 2) {
      return
    }

    const tmpData = setConditionalDelete()

    setTableData({
      ...tableData,
      reset: true,
      checked: false,
      localComparableData: [...normalize.calculateWtdAvgRowForUnitMix(tmpData, rowsCount)],
      selectedRows: [],
      isLastRec: tableData.localComparableData.length === 2
    })
  }

  const handleDeleteRow = rowNum => {
    // const cdata = tableData.localComparableData
    // let tmpData
    // if (cdata[rowNum].omniViewPropertyRentId) {
    //   tmpData = [...tableData.localComparableData]
    //   tmpData[rowNum].isRemoved = true
    // } else {
    //   tmpData = cdata.filter((data, index) => index !== rowNum)
    // }
    if (tableData.localComparableData.length <= 2) {
      return
    }
    const tmpData = setConditionalDelete(rowNum)
    setTableData({
      ...tableData,
      reset: true,
      localComparableData: [...normalize.calculateWtdAvgRowForUnitMix(tmpData, rowsCount)],
      isLastRec: tmpData.length === 2
    })
  }

  const handleUpdateRow = (row, index) => {
    const tempCData = tableData.localComparableData.map((t, i) => {
      if (i === index) {
        return !row.isAdded ? { ...row, isModified: true } : { ...row }
      }

      return t
    })
    const wtdAvgCalculated = [...normalize.calculateWtdAvgRowForUnitMix(tempCData, rowsCount)]
    setTableData({
      ...tableData,
      reset: true,
      localComparableData: wtdAvgCalculated
    })
  }

  const confirmAddRow = newRow => {
    setRowInEditFlag(false)
    const tempCData = [...tableData.localComparableData]
    if (tableData.localComparableData.length === 0) {
      const wtAvgRow = JSON.parse(JSON.stringify(newRow))
      wtAvgRow.units = 0
      tempCData.splice(0, 0, { ...wtAvgRow })
    }
    tempCData.splice(tempCData.length - 1, 0, { ...newRow, isAdded: true })
    setTableData({
      ...tableData,
      reset: true,
      localComparableData: [...normalize.calculateWtdAvgRowForUnitMix(tempCData, rowsCount, true, props.templateType)]
    })
  }

  const savePropertyDetails = () => {
    editUnitMixData({
      comparableData: tableData.localComparableData,
      propertyType: props.propertyType,
      unitMixDisclaimerData
    })
    doneColumnsDialog(tableData.dialogPropertyFields.propertyFields)
    togglePropertyWeightedAvg({
      propertyType,
      hideUnitMixTotal: isHideTotal
    })
    closeEditPopup()
  }

  const handleSelectChange = (position, event) => {
    const val = event.target.value
    const displayFields = tableData.dialogPropertyFields.propertyFields.map(
      (item, i) => {
        if (i === position) {
          let propetyLabel = tableData.dialogPropertyFields.allFields.filter(
            field => field.value === val
          )
          if (propetyLabel.length === 0) {
            propetyLabel = [{ key: 'NA', value: 'NA' }]
          }

          return propetyLabel[0]
        }

        return item
      }
    )

    setTableData({
      ...tableData,
      dialogPropertyFields: {
        ...tableData.dialogPropertyFields,
        propertyFields: displayFields,
        reset: true
      }
    })
  }

  const onDragStartColumns = originalIndex => () => {
    setTableData({
      ...tableData,
      dialogPropertyFields: {
        ...tableData.dialogPropertyFields,
        dragIndex: originalIndex,
        reset: true
      }
    })
  }

  const reArrangePropertyFields = (indexFrom, indexTo) => {
    const reArrangedPropertyFields = move(
      indexFrom,
      indexTo,
      tableData.dialogPropertyFields.propertyFields
    )
    setTableData({
      ...tableData,
      dialogPropertyFields: {
        ...tableData.dialogPropertyFields,
        propertyFields: reArrangedPropertyFields,
        reset: true
      }
    })
  }

  const onDropColumns = orderIndex => e => {
    e.preventDefault()
    if (orderIndex === tableData.dialogPropertyFields.dragIndex) {
      return
    }
    reArrangePropertyFields(
      tableData.dialogPropertyFields.dragIndex,
      orderIndex
    )
  }

  const handleResetColumns = () => {
    setTableData({
      ...tableData,
      dialogPropertyFields: {
        ...tableData.dialogPropertyFields,
        ...dialogProperties,
        reset: false
      }
    })
  }

  const modifyEditRowIndex = index => {
    setEditRowIndex(index)
  }

  const handleSetRowInEditFlag = val => setRowInEditFlag(val)

  const hideTotalHandler = toggleValue => {
    setIsHideTotal(toggleValue)
  }

  const handleDisclaimerEdit = () => setunitMixDisclaimerData({
    ...unitMixDisclaimerData,
    showDisclaimerForm: true
  })

  const handleDisclaimerTextUpdate = event => {
    event.preventDefault()
    setunitMixDisclaimerData({
      ...unitMixDisclaimerData,
      disclaimerText: event.target.disclaimerText.value,
      showDisclaimerForm: false
    })
  }

  const cancelDisclaimerTextUpdate = () => setunitMixDisclaimerData({
    ...unitMixDisclaimerData,
    disclaimerText: props.unitMixDisclaimerData?.disclaimerText,
    showDisclaimerForm: false
  })

  const handleShowDisclaimer = () => setunitMixDisclaimerData({
    ...unitMixDisclaimerData,
    showDisclaimer: !unitMixDisclaimerData.showDisclaimer
  })

  const handleCloseDialog = reason => {
    if (reason === 'backdropClick') {

      return false
    }

    return closeEditPopup
  }

  const dataTableProps = {
    // comparableData,
    rowsCount,
    propertyType,
    closeEditPopup,
    onHideToggle: hideTotalHandler,
    hideUnitMixTotal,
    onDragStart,
    onDragOver,
    onDrop,
    handleChange,
    onSelect,
    handleReset,
    handleDeleteSelected,
    handleDeleteRow,
    handleUpdateRow,
    savePropertyDetails,
    confirmAddRow,
    editRowIndex,
    isHideTotal,
    modifyEditRowIndex,
    handleSetRowInEditFlag,
    tableData,
    dataTableColumns: [...unitMixTableColumns],
    actionItems: {
      hasDelete: true,
      hasDragDrop: true,
      hasEdit: true,
      hasSelect: true,
      hasAdd: true
    },
    unitMixDisclaimerData,
    handleDisclaimerEdit
  }

  return (
    <div data-testid="edit-unit-mix-details">
      <Dialog
        onClose={handleCloseDialog}
        open={isDialogOpen}
        scroll="paper"
        maxWidth="sm"
        fullWidth={true}
        disableEscapeKeyDown={true}
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogTitle disableTypography className={classes.root}>
          <div className="unitmix-details">
            <div className="title">{dialogTitle}</div>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={closeEditPopup}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <Paper square>
          <Tabs
            value={value}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleTabChange}
            className={classes.tabs}
          >
            <Tab label="TABLE" {...a11yProps(0)} className={classes.tab} />
            <Tab label="COLUMNS" {...a11yProps(1)} className={classes.tab} />
          </Tabs>
          <TabPanel value={value} index={0} classes={classes}>
            <DataTable {...dataTableProps} />
          </TabPanel>
          <TabPanel value={value} index={1} classes={classes}>
            <EditColumns
              handleSelectChange={handleSelectChange}
              onDragStart={onDragStartColumns}
              reArrangePropertyFields={reArrangePropertyFields}
              onDrop={onDropColumns}
              onDragOver={onDragOver}
              handleReset={handleResetColumns}
              dialogPropertyFields={tableData.dialogPropertyFields}
              dialogProperties={dialogProperties}
              closeEditPopup={props.closeEditPopup}
              doneColumnsDialog={props.doneColumnsDialog}
            />
          </TabPanel>
        </Paper>
        <div>
          {unitMixDisclaimerData.showDisclaimerForm && (
            <div className="disclamier-container">
              <EditDisclaimeText
                disclaimerText={unitMixDisclaimerData.disclaimerText}
                updateDisclaimerText={handleDisclaimerTextUpdate}
                cancelDisclaimerText={cancelDisclaimerTextUpdate}
                showDisclaimer={unitMixDisclaimerData.showDisclaimer}
                handleShowDisclaimer={handleShowDisclaimer}
                defaultDisclaimerText={DEFAULT_DISCLAIMER_TEXT}
              />
            </div>
          )}
          {!unitMixDisclaimerData.showDisclaimerForm && (
            <div className="editColumns-btn-boxes">
              <Button
                className={`btn done ${rowInEditFlag && 'btn-disabled'}`}
                id="unitMixDetails-done"
                data-testid="columnsDetails-done"
                variant="contained"
                size="large"
                disabled={rowInEditFlag}
                onClick={savePropertyDetails}
              >
                <span className="tick">
                  <img src="/images/btn_done.svg" />
                </span>
                <span className="done">Done</span>
              </Button>
            </div>
          )}
        </div>
      </Dialog>
    </div>
  )
}

EditUnitMixDetails.propTypes = {
  propertyType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rowsCount: PropTypes.number,
  closeEditPopup: PropTypes.func,
  doneColumnsDialog: PropTypes.func,
  isDialogOpen: PropTypes.bool,
  classes: PropTypes.object,
  templateType: PropTypes.string,
  unitMixTableColumns: PropTypes.array,
  comparableData: PropTypes.array,
  editUnitMixData: PropTypes.func,
  togglePropertyWeightedAvg: PropTypes.func,
  hideUnitMixTotal: PropTypes.bool,
  unitMixDisclaimerData: PropTypes.object
}

export default withStyles(useStyles)(EditUnitMixDetails)
